import React from "react";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import OutlinedInput from "@mui/material/OutlinedInput";
import Select from "@mui/material/Select";
import { PublisherGameStatusDescription, PublisherGameStatusLabel } from "@seabrookstudios/pitch2table-core";

const Label = "Status";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").PublisherGameStatus} props.value
 * @param {Function} props.onChange
 * @param {boolean} [props.disabled]
 */
export const PublisherInterestStatusSelect = ({ value, onChange, disabled = false }) => {
  /**
   * @param {*} ev
   */
  const onChangeHandler = (ev) => {
    onChange(ev.target.value);
  };

  return (
    <FormControl sx={{ width: "100%" }} margin="normal" disabled={disabled}>
      <InputLabel id="publisher-status">{Label}</InputLabel>
      <Select
        labelId="publisher-status"
        value={value}
        onChange={onChangeHandler}
        label={Label}
        input={<OutlinedInput label={Label} />}
      >
        <MenuItem value="ShortListed">
          {PublisherGameStatusLabel.ShortListed} - {PublisherGameStatusDescription.ShortListed}
        </MenuItem>
        <MenuItem value="PitchSent">
          {PublisherGameStatusLabel.PitchSent} - {PublisherGameStatusDescription.PitchSent}
        </MenuItem>
        <MenuItem value="PitchReceived">
          {PublisherGameStatusLabel.PitchReceived} - {PublisherGameStatusDescription.PitchReceived}
        </MenuItem>
        <MenuItem value="InProgress">
          {PublisherGameStatusLabel.InProgress} - {PublisherGameStatusDescription.InProgress}
        </MenuItem>
        <MenuItem value="MaterialsRequested">
          {PublisherGameStatusLabel.MaterialsRequested} - {PublisherGameStatusDescription.MaterialsRequested}
        </MenuItem>
        <MenuItem value="UnderConsideration">
          {PublisherGameStatusLabel.UnderConsideration} - {PublisherGameStatusDescription.UnderConsideration}
        </MenuItem>
        <MenuItem value="InContractNegotiation">
          {PublisherGameStatusLabel.InContractNegotiation} - {PublisherGameStatusDescription.InContractNegotiation}
        </MenuItem>
        <MenuItem value="Signed">
          {PublisherGameStatusLabel.Signed} - {PublisherGameStatusDescription.Signed}
        </MenuItem>
        <MenuItem value="Withdrawn">
          {PublisherGameStatusLabel.Withdrawn} - {PublisherGameStatusDescription.Withdrawn}
        </MenuItem>
        <MenuItem value="Lost">
          {PublisherGameStatusLabel.Lost} - {PublisherGameStatusDescription.Lost}
        </MenuItem>
        <MenuItem value="Declined">
          {PublisherGameStatusLabel.Declined} - {PublisherGameStatusDescription.Declined}
        </MenuItem>
        <MenuItem value="NotAcceptingSubmissions">
          {PublisherGameStatusLabel.NotAcceptingSubmissions} - {PublisherGameStatusDescription.NotAcceptingSubmissions}
        </MenuItem>
      </Select>
      <FormHelperText>{PublisherGameStatusDescription[value] || ""}</FormHelperText>
    </FormControl>
  );
};
